export default {"src":"/_next/static/media/rocket.50e5ba4d.svg","height":400,"width":400};